import { useCurrentUserContext } from 'contexts/currentUser';
import { useFeatureFlags } from 'hooks/useFeatureFlags';

export const useSeriesNav = () => {
  const { currentUser } = useCurrentUserContext();

  const {
    flags: { enableSeriesOnboardingPacks = false },
  } = useFeatureFlags();
  return (
    enableSeriesOnboardingPacks &&
    !currentUser?.anyUserSportProfile?.proUnlocked
  );
};
